import { useAuthStore } from "../store";
import { Outlet, Navigate } from "react-router-dom";
import { ROUTES } from "./routes";
import { LoadingSpinner } from "../shared/components/ui/LoadingSpinner";

// Redirects to dashboards by role
const dashboardRedirects: Record<string, string> = {
  LIFEGUARD: ROUTES.DASHBOARD.LIFEGUARD,
  ADMINISTRATOR: ROUTES.DASHBOARD.ADMINISTRATOR,
};
export const PublicRoute: React.FC = () => {
  const { isAuthenticated, isPreAuthenticated, user, isLoading } =
    useAuthStore();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (isAuthenticated && user?.role) {
    const redirectTo =
      dashboardRedirects[user.role] ?? ROUTES.PRE_LOGIN.LIFEGUARD;
    return <Navigate to={redirectTo} replace />;
  }
  
  if (isPreAuthenticated) {
    return <Navigate to={ROUTES.AGREEMENT.LIFEGUARD} replace />;
  }

  return <Outlet />;
};
